var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadPdfIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 18V2H24.6672L34 12.1941V18",
    stroke: "#2A2A2A",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0372 27.7225H5.74125V25.794H9.0372C9.54655 25.794 9.96113 25.717 10.281 25.5632C10.6008 25.4038 10.8347 25.1841 10.9828 24.9038C11.1309 24.6236 11.2049 24.3077 11.2049 23.956C11.2049 23.5989 11.1309 23.2665 10.9828 22.9588C10.8347 22.6511 10.6008 22.4038 10.281 22.217C9.96113 22.0302 9.54655 21.9368 9.0372 21.9368H6.66519V32H4V20H9.0372C10.05 20 10.9176 20.1703 11.6402 20.511C12.3687 20.8462 12.9254 21.3104 13.3104 21.9038C13.6954 22.4973 13.8878 23.1758 13.8878 23.9396C13.8878 24.7143 13.6954 25.3846 13.3104 25.9505C12.9254 26.5165 12.3687 26.9533 11.6402 27.261C10.9176 27.5687 10.05 27.7225 9.0372 27.7225Z",
    fill: "#2A2A2A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6979 32H16.8817L16.8995 30.0714H19.6979C20.3968 30.0714 20.9861 29.9258 21.4659 29.6346C21.9456 29.3379 22.3069 28.9066 22.5497 28.3407C22.7984 27.7747 22.9228 27.0907 22.9228 26.2885V25.7033C22.9228 25.0879 22.8517 24.5467 22.7096 24.0797C22.5734 23.6126 22.3691 23.2198 22.0966 22.9011C21.8242 22.5824 21.4895 22.3434 21.0927 22.1841C20.6959 22.0192 20.2399 21.9368 19.7246 21.9368H16.8284V20H19.7246C20.5893 20 21.38 20.1374 22.0966 20.4121C22.8192 20.6813 23.444 21.0687 23.9711 21.5742C24.4982 22.0797 24.9039 22.6841 25.1882 23.3874C25.4784 24.0852 25.6235 24.8626 25.6235 25.7198V26.2885C25.6235 27.1401 25.4784 27.9176 25.1882 28.6209C24.9039 29.3242 24.4982 29.9286 23.9711 30.4341C23.4499 30.9341 22.8251 31.3214 22.0966 31.5962C21.3741 31.8654 20.5745 32 19.6979 32ZM18.392 20V32H15.7268V20H18.392Z",
    fill: "#2A2A2A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2254 20V32H27.5602V20H30.2254ZM35.3781 25.1264V27.0549H29.4969V25.1264H35.3781ZM36 20V21.9368H29.4969V20H36Z",
    fill: "#2A2A2A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 18L19.9998 9M19.9998 9L24.7998 13.6773M19.9998 9L15.1998 13.6773",
    stroke: "#2A2A2A",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 34L6 38H34V34",
    stroke: "#2A2A2A",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadPdfIcon);
export default __webpack_public_path__ + "static/media/upload_pdf_icon.893b8a45.svg";
export { ForwardRef as ReactComponent };